// 八字服务 — 使用统一 axios 实例
import api from '@/api/client'

export async function analyzeBazi(data) {
  try {
    const response = await api.post('/api/ai/bazi', data)
    return response.analysis  // 返回 analysis 字段，不是整个 response
  } catch (error) {
    console.error('八字分析失败:', error)
    throw error
  }
}

export default {
  analyzeBazi
}
